module.exports = __webpack_public_path__ + "static/media/beach-1.79003abe.jpg";